import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';

import { isNonRetryablePaymentOperation } from './nonRetryablePaymentOps';

// import { API_BASE_URI, ORIGIN, BOOKER } from '../constants';

/**
 * GRAPHQL APOLLO CLIENT
 */
const httpLink = createHttpLink({
  // uri: `${API_BASE_URI}/graphql`,
  uri: () => `${global.apiBasePath}/graphql`,
});

// return the headers to the context so httpLink can read them
const authLink = setContext((_, {
 headers, accessToken, sessionToken, golfId,
}) => {
  const newHeaders = { ...headers };
  const { booker, origin, apiVersion } = global;
  if (golfId) newHeaders['x-golf'] = golfId;
  if (booker) newHeaders['x-booker'] = booker;
  if (origin) newHeaders['x-origin'] = origin;
  if (apiVersion) newHeaders['x-version'] = apiVersion;
  if (accessToken) newHeaders['x-access-token'] = accessToken;
  if (sessionToken) newHeaders['x-session-token'] = sessionToken;
  return { headers: newHeaders };
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error, operation) => {
      // Ne JAMAIS rejouer une opération de paiement / création de commande : un
      // rejeu après réponse perdue = double débit / double commande. Le test
      // historique `startsWith('payline')` (minuscule) ne matchait jamais les
      // opérations `Payline*` (PascalCase) -> voir nonRetryablePaymentOps.js.
      if (isNonRetryablePaymentOperation(operation.operationName)) {
        return false;
      }
      // Retry network errors for all other operations
      return !!error && (error.networkError || error.networkError?.statusCode >= 500);
    },
  },
});

const errorLink = onError(
  ({
    response,
    graphQLErrors,
    networkError,
    // operation,
    // forward,
  }) => {
    if (graphQLErrors) {
      // console.log('graphQLErrors', graphQLErrors);
      let hasError = false;
      for (let i = 0; i < graphQLErrors.length; i += 1) {
        const {
          message,
          extensions,
          // locations,
          // path,
        } = graphQLErrors[i];
        switch (extensions && extensions.code) {
          // case 'UNAUTHENTICATED': {
          //   // error code is set to UNAUTHENTICATED
          //   // when AuthenticationError thrown in resolver
          //
          //   // modify the operation context with a new token
          //   const oldHeaders = operation.getContext().headers;
          //   operation.setContext({
          //     headers: {
          //       ...oldHeaders,
          //       authorization: getNewToken(),
          //     },
          //   });
          //   // retry the request, returning the new observable
          //   return forward(operation);
          // }
          default:
            if (response && !hasError) {
              response.errors = [{ message: message || 'errors.internal' }];
              hasError = true; // only one error
            }
        }
      }
    }
    if (networkError) {
      // Même correction que dans `masterClient.js`, et pour la même raison : un
      // `networkError` couvre aussi les réponses HTTP non-2xx. Voir le commentaire
      // détaillé là-bas. `statusCode` présent = le serveur a répondu.
      if (response) {
        response.errors = [{ message: networkError.statusCode ? 'errors.server_error' : 'errors.network' }];
      }
    }
    return null;
  },
);

const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, retryLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
});

export default apolloClient;
